export default "__VITE_ASSET__53ac9fac__"